import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  Input,
} from '@angular/core';
import {
  ModalController,
  App,
  NavController,
  ToastController,
} from 'ionic-angular';
import { UserProvider } from '../../../providers/user/user';
import { ToolsProvider } from '../../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import { AppVersion } from '@ionic-native/app-version';
import { EnvVariables } from '../../../environments/environment';
import { ConfigProvider } from '../../../providers/config/config';
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
import { LiveChatProvider } from '../../../providers/live-chat/live-chat';

@Component({
  selector: 'lc-chat-carousel',
  templateUrl: 'chat-carousel.html',
})
export class ChatCarouselComponent {
  log = debug('app:ChatCarouselComponent');

  @Output() navToLiveChat = new EventEmitter();
  @Input() chatToShow = 'Popular';

  chatTypes: any[] = ['Popular', 'Discover', 'Active'];
  loading = true;
  subscribe: boolean = false;
  allPublicChats: any;
  rooms: any[] = [];
  chatTitle: string = '';
  expandedRooms = [];
  otherRooms = [];
  conversation: any = {};
  totalUsersInChat: any;
  room: any;
  user_id: string;
  messageRepliesCount = 0;

  //ToDo : randomize color backgrounds for chat icons
  //ToDo: Feed Slotting

  constructor(
    public modalCtrl: ModalController,
    public user: UserProvider,
    public appCtrl: App,
    public tools: ToolsProvider,
    public appVersion: AppVersion,
    public navCtrl: NavController,
    private env: EnvVariables,
    public configs: ConfigProvider,
    public liveChat: LiveChatProvider,
    public toastCtrl: ToastController
  ) {}

  ngOnInit(): void {
    this.chatsToShow(this.chatToShow);
  }

  async navToGeneralChat(event, convo) {
    this.preventDefaults(event);
    this.liveChat
      .getConversation(convo)
      .then(conversation => {
        this.tools.logAnalyticsEvent(
          'trackCustom',
          `lc-view-chatCarousel-navToGeneralChat`
        );
        // TODO navTo
        // this.tools.openExternalUrl(
        //   `/home/chat/${conversation._id}`,
        //   'deep-link'
        // );
        this.tools.navTo('ChatPage', 1, {conversation_id: conversation._id});
      })
      .catch(e => {
        this.log('error getting conversation');
        const toast = this.toastCtrl.create({
          message:
            'An error occurred while retrieving this conversation. Please check your connection and try again. If the issue continues, please contact us for help.',
          position: 'top',
          duration: 5000,
        });
        toast.present();
      });
  }

  private preventDefaults(event) {
    try {
      event.preventDefault();
      event.stopPropagation();
    } catch (e) {}
  }

  chatsToShow(type) {
    switch (type) {
      case 'Popular':
        this.liveChat.getPopularRooms().then(popularRooms => {
          this.rooms = popularRooms;
          _.each(this.rooms, rm => {
            rm.dates.created = moment(rm.dates.created).fromNow();

            if (_.includes(['general'], rm.socketId)) {
              rm.expandChat = true;
            } else {
              rm.expandChat = false;
            }
          });

          this.expandedRooms = _.filter(this.rooms, rm => rm.expandChat);
          this.otherRooms = _.filter(this.rooms, rm => !rm.expandChat);
          this.totalUsersInChat = _.size(this.expandedRooms[0].userIds);
        });
        break;
      case 'Discover':
        this.liveChat.discoverRooms().then(newRoom => {
          this.rooms = newRoom;
        });
        break;
      case 'Active':
        this.liveChat.getActiveRooms().then(activeRooms => {
          if (!_.size(activeRooms)) {
            this.chatToShow = 'Discover';
            this.chatsToShow(this.chatToShow);
          } else {
            this.rooms = activeRooms;
          }
        });
        break;
    }
  }

  navToLiveChatPage() {
    this.tools.logAnalyticsEvent(
      'trackCustom',
      `lc-view-chatCarousel-navToLiveChatPage`
    );
    this.navToLiveChat.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/chat-carousel/chat-carousel.ts